import ServiceDetail from '@/components/feature/ServiceDetail';

export default function VideoEditingPage() {
  return <ServiceDetail slug="video-editing" />;
}